import api from 'libs/api';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import _ from 'lodash';

export const getOrganisationByVatIdentificationNumber =  _.memoize(async (vatIdentificationNumber: string) => {
  const resp = await api.post('/Organisations/validate-vat-identification-number', {vatIdentificationNumber});
  return resp;
});

export const getOrganisationByVatIdentificationNumberDebounced = AwesomeDebouncePromise(getOrganisationByVatIdentificationNumber,400, {leading: true});

const sleep = (ms:any) => new Promise(resolve => setTimeout(resolve, ms));

async function validateVatIdentificationNumber(value:string) {
  if (!value) {
    return null;// 'Required';
  }
  const organisation = (await getOrganisationByVatIdentificationNumberDebounced(value)) as any;

  if (!organisation.isVatIdentificationNumberValid ) {
    return "VAT ID not valid according to the European Commission";
  }
  return null;
};


// export default _.debounce(validateVatIdentificationNumber,400);
export default validateVatIdentificationNumber;
